import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/pixel";

/**
 * Mount once inside <BrowserRouter>. Fires PageView on every pathname change.
 *
 * Strategy: the inline pixel snippet in public/index.html fires the FIRST
 * PageView before React mounts, and stamps `window.__ssLastTrackedPath` with
 * the initial pathname. This effect only fires when the current pathname
 * differs from that stamp — naturally suppressing both the first-mount and
 * any React StrictMode double-mount in dev (StrictMode's repeat call sees an
 * already-matching stamp and skips).
 */
export default function PixelRouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const last = typeof window !== "undefined" ? window.__ssLastTrackedPath : null;
    if (last !== pathname) {
      if (typeof window !== "undefined") window.__ssLastTrackedPath = pathname;
      trackPageView();
    }
  }, [pathname]);
  return null;
}
